import React, {Component, Fragment} from 'react';
import {connect} from 'react-redux';
import {Alert} from 'reactstrap';
import trainingPhasesActionCreators from '../../store/training-phases/action-creators/index';
import PhaseReportTableRow from './PhaseReportTableRow';
import {isReportActionNeeded} from "../../services/sign-flow";
import oitsSelectors from "../../store/oits/selectors";

class PhaseReportTable extends Component {
  constructor(props) {
    super(props);
    this.state = {
      type: '',
      filterByStatus: this.canOnlyViewCompleted? 'closed': 'opened',
      sort: {
        prop: 'date',
        direction: 'desc',
      },
    };
  }

  // ----------------------
  // Lifecycle
  // ----------------------

  componentDidMount() {
    if(this.props.reports) {
      let reports = this.props.reports.filter(this.filterByStatus.bind(this));
      if(!reports.length) {
        this.setState({
          filterByStatus: 'all',
        });
      }
    }
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.reports) {
      let reports = nextProps.reports.filter(this.filterByStatus.bind(this));
      if(!reports.length) {
        this.setState({
          filterByStatus: 'all',
        });
      }
    }
  }

  // ----------------------
  // Methods
  // ----------------------

  onSendReminder(reportGuid) {
    const formData = {
      guid: reportGuid,
      sentAt: new Date().toISOString(),
    };
    this.props.sendReminder(formData);
  }

  filterByType(reportType, filteredReports) {
    const fr = !reportType
      ? filteredReports
      : filteredReports.filter(report => report.type === reportType);
    return fr;

  }

  setFilterType(type){
    this.setState({
      type
    })
  }

  sortByProperty(property) {
    if (property === this.state.sort.prop) {
      if (this.state.sort.direction === 'desc') {
        this.setState({
          sort: {
            prop: property,
            direction: 'asc',
          },
        });
      } else {
        this.setState({
          sort: {
            prop: property,
            direction: 'desc',
          },
        });
      }
    } else {
      this.setState({
        sort: {
          prop: property,
          direction: 'asc',
        },
      });
    }
  }

  filterByStatus(report) {
    if(this.state.filterByStatus === 'opened') {
      return !report.getIsCompleted();
    } else if(this.state.filterByStatus === 'closed') {
      return report.getIsCompleted()
        || (
          this.props.userContext.hasScope(['oit', 'cstaff', 'chief'])
          && isReportActionNeeded(this.props.userContext.scope, report)
        );
    } else {
      return true;
    }
  }

  setFilterStatus(status) {
    this.setState({
      filterByStatus: status
    })
  }

  // ----------------------
  // Computed
  // ----------------------

  get filteredReports() {

    let filteredReports = this.props.reports.filter(this.filterByStatus.bind(this));

    filteredReports = this.filterByType(this.state.type, filteredReports);

    if (this.state.sort.prop != null) {
      filteredReports.sort(this.compareReports.bind(this));

      if (this.state.sort.direction === 'desc') {
        filteredReports = filteredReports.reverse();
      }
    }
    return filteredReports;
  }


  compareReports(r1, r2) {

    let date1 = new Date(r1.date).getTime();
    let date2 = new Date(r2.date).getTime();

    if (date1 < date2) {
      return -1;
    } else if (
      date1 > date2
    ) {
      return 1;
    }
    return 0;
  }

  // ----------------------
  // getters
  // ----------------------

  get canOnlyViewCompleted() {
    return this.props.userContext.hasScope(['cstaff', 'chief'])
  }

  // ----------------------
  // Render
  // ----------------------

  render() {
    return (
      <div>

        <form className="table-filters">

          {!this.canOnlyViewCompleted && (
            <div className="form-group">
              {/* eslint-disable-next-line */}
              <label>Filter by status</label>
              <select
                className="form-control"
                id="filterByStatus"
                name="filterByStatus"
                onChange={event => this.setFilterStatus(event.target.value)}
                value={this.state.filterByStatus}
              >
                <option value="opened">In progress</option>
                <option value="closed">Completed</option>
                <option value="all">All</option>
              </select>
            </div>
          )}

          <div className="form-group">
            {/* eslint-disable-next-line */}
            <label>Filter by type</label>
            <select
              className="form-control"
              id="filterByType"
              name="filterByType"
              onChange={event => this.setFilterType(event.target.value)}
              value={this.state.filterByType}
            >
              <option value="">All</option>

              {this.props.isDorAvailable && (
                <option value="dor">Daily Observation Report</option>
              )}
              {!this.props.phase.hasOpenRemedial && this.props.isEopAvailable &&
                <option value="eop">End of Phase Report</option>
              }
              {this.props.phase.hasOpenRemedial &&
                <option value="cont">Field Training Continuation</option>
              }
              {!this.props.phase.hasOpenRemedial && this.props.isRrtAvailable &&
                <option value="rrt">Request for Additional Training</option>
              }
              {/*<option value="journal">Recruit Daily Journal</option>*!/*/}
              {this.props.availableReports.map((report) => (
                <option key={report.type} value={report.type}>{report.name}</option>
              ))}
            </select>
          </div>

        </form>
        {!this.filteredReports.length ? (
          <Alert color="primary">No reports for selected type</Alert>
        ) : (
          <Fragment>
            <div className="table-scrollable">
              <table className="table table-stripped">
                <thead>
                <tr>
                  <th onClick={() => this.sortByProperty('date')}>
                    <div className="header">
                      <span>Date </span>
                      <div className="filterActions">
                        {
                          this.state.sort.prop === 'date' ? (
                            this.state.sort.direction === 'asc' ? (
                              <i className="fa fa-angle-up"/>
                            ) : (
                              <i className="fa fa-angle-down"/>
                            )
                          ) : (
                            <Fragment>
                              <i className="fa fa-angle-up"/>
                              <i className="fa fa-angle-down"/>
                            </Fragment>
                          )
                        }
                      </div>
                    </div>
                  </th>
                  <th>
                    <div className="header">
                      <span>Type </span>
                    </div>
                  </th>
                  <th>
                    <div className="header">
                      <span>Progress </span>
                    </div>
                  </th>
                  <th>
                    <div className="header">
                      <span>Status </span>
                    </div>
                  </th>
                  <th>
                    <div className="header">
                      <span>Author</span>
                    </div>
                  </th>
                  <th>
                    <div className="header">
                      <span>Actions </span>
                    </div>
                  </th>
                </tr>
                </thead>
                <tbody>
                {this.filteredReports.map((report, index) => {
                  return (
                    <PhaseReportTableRow
                      key={index.toString()}
                      onAddScheduledReport={(reportGuid, type) => {
                        return this.props.addScheduledReport(reportGuid, type);
                      }}
                      onDeleteDraftReport={(reportGuid) => {
                        return this.props.deleteDraftReport(reportGuid);
                      }}
                      onDeleteScheduledReport={(reportGuid) => {
                        return this.props.deleteScheduledReport(reportGuid);
                      }}
                      onSendReminder={reportGuid => this.onSendReminder(reportGuid)}
                      onViewReport={reportGuid => this.props.viewReport(reportGuid)}
                      onEditReport={reportGuid => this.props.editReport(reportGuid)}
                      onRewriteReport={reportGuid => this.props.rewriteReport(reportGuid)}
                      report={report}
                      phase={this.props.phase}
                    />
                  );
                })}
                </tbody>
              </table>
            </div>
          </Fragment>
        )}
      </div>
    );
  }
}

// ----------------------
// Redux Mappings
// ----------------------

const mapStateToProps = (state) => {
  return {
    userContext: state.common.userContext,
    availableReports: oitsSelectors.selectedOitAvailableReports(state),
    isEopAvailable: oitsSelectors.isEopAvailable(state),
    isDorAvailable: oitsSelectors.isDorAvailable(state),
    isRrtAvailable: oitsSelectors.isRrtAvailable(state),
  }
}


const mapDispatchToProps = (dispatch) => {
  return {
    addScheduledReport: (reportGuid, type) => {
      return dispatch(trainingPhasesActionCreators.addScheduledReport(reportGuid, type));
    },
    deleteDraftReport: (reportGuid) => {
      return dispatch(trainingPhasesActionCreators.deleteDraftReport(reportGuid));
    },
    deleteScheduledReport: (reportGuid) => {
      return dispatch(trainingPhasesActionCreators.deleteScheduledReport(reportGuid));
    },
    editReport: (reportGuid) => {
      return dispatch(trainingPhasesActionCreators.editReport(reportGuid));
    },
    rewriteReport: (reportGuid) => {
      return dispatch(trainingPhasesActionCreators.rewriteReport(reportGuid));
    },
    sendReminder: (formData) => {
      return dispatch(trainingPhasesActionCreators.sendReminder(formData));
    },
    viewReport: (reportGuid) => {
      return dispatch(trainingPhasesActionCreators.viewReport(reportGuid));
    },
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(PhaseReportTable);
